module.exports = __webpack_public_path__ + "static/img/xl_btn1.2ba03fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/xl_btn1.png
// module id = JAua
// module chunks = 7